import React from "react";
import { render } from "react-dom";
import BlogPromoSubscription from "../widgets/BlogPromoSubscription/BlogPromoSubscription";

const container = document.querySelector("#blog-promo-subscription");
if (container) render(<BlogPromoSubscription />, container);
